/**
 * ONE COLOUR PER LISTING, IN A COMBINED INVENTORY'S CHARTS AND SHARE BARS.
 *
 * The dashboard's "By listing" table and its per-listing "Priced at" lines describe the same
 * listings side by side, so a listing wears the same colour in both. The colour follows the
 * listing, never its rank in a window: the backend sends each listing's `slot`, its place in the
 * combined inventory's own order (lead first, then by name, App::PricingUnit#properties), and the
 * page reads the colour off that.
 *
 * The lead is the primary teal, as on every hotel badge (lib/hotel-palette LEAD_TONE); the first
 * following listing is indigo, as on its badge. The next two are the reference categorical slots
 * (orange, sky) rather than the badge palette's fuchsia and sky: indigo beside fuchsia cannot be
 * told apart under colour-vision deficiency (validated: protan ΔE 2.9), and a chart line has no
 * text on it to fall back on. This order passes every adjacent-pair check for lines, and its first
 * three pass all pairs. A fifth listing and beyond is drawn slate and dashed, never a cycled hue.
 */
export const LISTING_COLORS = ['#0d9488', '#4f46e5', '#eb6834', '#0284c7'] as const

/** Slate, for a listing past the validated palette. Paired with a dash so it is not colour alone. */
export const LISTING_OVERFLOW_COLOR = '#64748b'

export function listingColor(slot: number): string {
  return LISTING_COLORS[slot] ?? LISTING_OVERFLOW_COLOR
}

/** A dash pattern for a line past the palette, so its identity never rests on colour alone. */
export function listingDash(slot: number): string | undefined {
  return slot < LISTING_COLORS.length ? undefined : '6 4'
}
